export default "__VITE_ASSET__DqWNnmEf__"